import React, { useState } from 'react'
import styled from "styled-components";
import { IconButton } from '@workboard/wobo-ui';
import HelpOutline from '@material-ui/icons/HelpOutline';



function CustomName({ title, tooltip, isReq }) {
    const [alignsHelpPopUp, setAlignsHelpPopUp] = useState(false);
    const StyledIconButton = styled(IconButton)`
    &.MuiButtonBase-root{
      margin-left: 5px;
    
    }
      width: 16px;
      height: 16px;
      svg {
        width: 14px;
        height: 14px;
      }
  `;

    return (
        <div>
            <div className="aEObjectiveAchi editObjhelpIconPosition"
                style={{ marginTop: '12px' }}
            >
                <div className="ObjectiveAchiText">{title}{isReq == '1' ? <span className="typefacetext">*</span> : ''}</div>
                <div className="editObj-help_tooltip-position">
                    {tooltip ? (<StyledIconButton

                        onMouseEnter={event => {
                            setAlignsHelpPopUp(
                                value => !value
                            );
                        }}
                        onMouseLeave={event => {
                            setAlignsHelpPopUp(
                                value => !value
                            );
                        }}
                    > <HelpOutline />
                    </StyledIconButton>) : ''}



                    {alignsHelpPopUp && (
                        <div className="form-popup editObjTooltipContentPosition"
                            style={{ width: 'max-content', maxWidth: '400px', height: 'max-content', overflow: 'auto', minHeight: 'fit-content' }}

                            onMouseEnter={event => { setAlignsHelpPopUp(true) }}
                            onMouseLeave={event => { setAlignsHelpPopUp(false) }}

                        >
                            <a style={{ color: '#687587' }}>{tooltip}</a>

                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CustomName